/* eslint-disable */

import React, { PureComponent } from 'react';
import { Button, Grid, Icon, Input, Popup } from 'semantic-ui-react';
import moment from 'moment';

class NoteDetail extends PureComponent {
  state = {
    clearNoteOpen: false,
    note: ''
  };

  getIconName = (noteType) => {
    switch (noteType) {
      case '0':
      case '4':
        return 'comments';
      case '1':
        return 'check';
      case '2':
        return 'stop';
      case '3':
      case '5':
        return 'warning sign';
      default:
        return 'comments';
    }
  };

  getIconColor = (note) => {
    switch (note.note_type) {
      case '0':
      case '4':
        return note.note_qc ? 'yellow' : 'green';
      case '1':
        return 'green';
      case '2':
        return 'grey';
      case '3':
        return 'red';
      case '5':
        return 'green';
      default:
        return 'green';
    }
  };

  render() {
    const { adNote } = this.props;
    const date = moment(adNote.createdDate);
    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <p>{adNote.noteText}</p>
          <small>
            {adNote.fullname === '' ? adNote.username : adNote.fullname} -{' '}
            <i>{date.fromNow()}</i>
          </small>
          <Icon
            name={this.getIconName(adNote.note_type)}
            color={this.getIconColor(adNote)}
            inverted={adNote.note_type === '2'}
          />
        </Grid.Column>
        {adNote.note_qc ? (
          <Grid.Column width={16}>
            <Popup
              flowing
              on="click"
              open={this.state.clearNoteOpen}
              trigger={
                <Button
                  onClick={() => {
                    this.setState({
                      clearNoteOpen: !this.state.clearNoteOpen,
                      holdOpen: false
                    });
                  }}
                  color="green"
                >
                  Clear Note
                </Button>
              }
            >
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Input
                      fluid
                      placeholder="Add Note to the Clear Note"
                      value={this.state.note}
                      onChange={(event, data) => {
                        this.setState({ note: data.value });
                      }}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Button
                      onClick={() => {
                        this.clearNote();
                      }}
                      color="blue"
                    >
                      Clear
                    </Button>
                    <Button
                      onClick={() => {
                        this.setState({ clearNoteOpen: false, note: '' });
                      }}
                      color="red"
                    >
                      Cancel
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Popup>
          </Grid.Column>
        ) : null}
      </Grid.Row>
    );
  }
}

export default NoteDetail;



// WEBPACK FOOTER //
// ./src/screens/Compliance/components/NoteDetail.js